import React from "react";
import Calculator from "./components/Calculator";
import "./App.css";

function App() {
  return (
    <div id="App">
      <Calculator></Calculator>
    </div>
  );
}

export default App;
